import React, { useState } from 'react'
import { FC } from 'react'
import Roles from '../../../models/roles'
import TrashIcon from '../../UI/Icons/Trash'
import LoadableImage from '../../UI/LoadableImage'

import Select from 'react-select'
import { transformRoleName } from '../../../pages/Settings/Team'

import './../../UI/Inputs/MultiselectInput/MultiselectInput.scss'
import './RoleSelect.scss'

const availableRoles = Object.values(Roles).filter(
  (role) => role !== Roles.AGENCY_ADMIN && role !== Roles.SUPER_ADMIN
)

const MultiValue: FC<any> = ({ data, components, removeProps, ...props }) => {
  const [role, setRole] = useState<Roles>(data.member.role)

  const onClick = (event: React.MouseEvent) => {
    event.stopPropagation()
  }

  const onChangeRole = (value: any) => {
    setRole(value.value as Roles)
    data.member.role = value.value
  }

  return (
    <div key={`agency-member-${data.member.id}`} className='label-member-wrapper'>
      <div className='label-member'>
        <div className='label-member__avatar-wrapper'>
          <LoadableImage isDisableAnimation={true} media={data.member.avatar} />
        </div>
        <div className='label-member__data' onMouseDown={onClick}>
          <div className='label-member__data__name'>{data.member.name}</div>
          <Select
            isSearchable={false}
            options={availableRoles.map((role) => ({
              label: transformRoleName(role),
              value: role
            }))}
            className='measure-select'
            classNamePrefix='measure-select'
            onChange={onChangeRole}
            value={{ value: role, label: transformRoleName(role) }}
          />
        </div>
      </div>
      <div
        className='label-member__remove'
        onClick={removeProps.onClick}
        onMouseDown={removeProps.onMouseDown}
      >
        <TrashIcon size={16} />
      </div>
    </div>
  )
}

export default MultiValue
